"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => ({
  label: {
    fontWeight: theme.typography.fontWeightBold
  },
  selectedLabel: {
    color: theme.palette?.primary?.main
  }
}));
var _default = exports.default = styles;